import { render } from "./ErrorAxios.vue?vue&type=template&id=9ad32104&scoped=true"
const script = {}

import "./ErrorAxios.vue?vue&type=style&index=0&id=9ad32104&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad32104"]])

export default __exports__